var addOneDay = function addOneDay(date) {
  return new Date(new Date(date).setDate(date.getDate() + 1));
};

var daysAgo = function daysAgo(offset) {
  if (offset === void 0) {
    offset = 1;
  }

  return function (date) {
    if (date === void 0) {
      date = new Date();
    }

    return new Date(new Date(date).setDate(date.getDate() - offset));
  };
};

var monthsAgo = function monthsAgo(offset) {
  if (offset === void 0) {
    offset = 1;
  }

  return function (date) {
    if (date === void 0) {
      date = new Date();
    }

    return new Date(new Date(date).setMonth(date.getMonth() - offset));
  };
};

var yearsAgo = function yearsAgo(offset) {
  if (offset === void 0) {
    offset = 1;
  }

  return function (date) {
    if (date === void 0) {
      date = new Date();
    }

    return new Date(new Date(date).setFullYear(date.getFullYear() - offset));
  };
};

var getRange = function getRange(converter) {
  return function (label, date) {
    if (date === void 0) {
      date = new Date();
    }

    return {
      label: label,
      startDate: addOneDay(converter(date)),
      endDate: date
    };
  };
};

export var week = getRange(daysAgo(7));
export var month = getRange(monthsAgo(1));
export var year = getRange(yearsAgo(1));
export var fourWeeks = getRange(daysAgo(4 * 7));
export var threeMonths = getRange(monthsAgo(3));
export var sixMonths = getRange(monthsAgo(6));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/Header/filters/daterange/DateRangePickerPresets.js
// module id = 365
// module chunks = 0